// render

import { createColumnHelper } from "@tanstack/react-table";
import { useSelector } from "react-redux";
import DashboardTable from "./DashboardTable";
import { Link } from "react-router-dom";

const columnHelper = createColumnHelper();

function ContainersTable() {
  const { dashboardData, dashboardLoading, dashboardError } = useSelector(
    (state) => state.dashboard
  );
  const { containerStatusData } = useSelector((state) => state.containers);

  const containers = dashboardData?.data?.containers;

  const containersData = containers?.byStatus
    ? Object.entries(containers.byStatus).map(([status, count]) => ({
        status,
        count,
      }))
    : [];

  const getEnumVal = (statusName) => {
    const statusObj = containerStatusData?.find(
      (s) => s.name.toLowerCase() === statusName.toLowerCase()
    );
    return statusObj?.enumVal || "unknown";
  };

  const containersColumns = [
    columnHelper.accessor("status", {
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          STATUS
        </p>
      ),
      cell: (info) => {
        const enumVal = getEnumVal(info.getValue());
        return (
          <Link
            to={`/containers/${enumVal}`}
            className="text-sm font-bold text-navy-700 dark:text-white"
          >
            {info.getValue()}
          </Link>
        );
      },
    }),
    columnHelper.accessor("count", {
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">COUNT</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
  ];

  return (
    <DashboardTable
      title="Containers Table"
      columns={containersColumns}
      data={containersData}
      loading={dashboardLoading}
      error={dashboardError}
    />
  );
}

export default ContainersTable;
